import styled from 'styled-components';

import { fontFamilySize, px } from '../../contrib/ui';

export const IncompleteEnrollmentAlert = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 150, 2, 0.9);
  z-index: 1;
  border-radius: 3px;
  padding: ${px(10)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  &:hover {
    background-color: rgba(255, 150, 2, 1);
  }

  p {
    width: 100%;
    text-align: center;

    color: white;
    ${fontFamilySize('Bold', 16)};
    margin: 0;
    line-height: 1.3;

    .corner-arrow {
      transform: rotate(90deg);
      color: white;

      &:hover {
        color: var(--mainColor);
        cursor: pointer;
      }
    }
  }
`;
